<template>
  <div class="lis">
    <el-card v-loading='loading'>

      <!-- <el-button type="primary" size="mini" icon="el-icon-search" @click="newSearch" style="margin-right:10px">新搜索</el-button> -->
      <el-input
      v-model="input"
      size="mini"
      style="width: 105px; margin-right: 10px"
      placeholder="请输入订单id"
      clearable>
      </el-input>
      <el-button type="primary" size="mini" @click="search" icon="el-icon-search">搜索</el-button>
      <!-- <el-button type="primary" size="mini" @click="reset()" icon="el-icon-refresh">重置</el-button> -->
      <el-button type="success" size="mini" @click="goProduct">订单商品列表</el-button>
      <!-- <el-button type="success" size="mini" @click="goData">图表数据</el-button> -->
      <!-- <el-button type="success" size="mini" @click="goTime">时间筛选</el-button> -->
      <el-button type="success" size="mini" @click="trace">追踪订单</el-button>
      <!-- <el-button type="success" size="mini" @click="goLog">操作记录</el-button> -->
      <el-button type="warning" size="mini" @click="export_">导出</el-button>
      <el-button type="success" size="mini" @click="SKU">SKU设置</el-button>
      <el-button type="success" size="mini" @click="Domain" v-if="UN">域名管理</el-button>
          <!-- @change="block" -->
      <div class="block">
        <el-date-picker
          :default-time="['00:00:00','23:59:59']"
          size="mini"
          style="width:320px;margin-left:60px"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>

      <!-- 请选择站点 -->
      <el-select size="mini" style="margin-left: 10px" v-model="selectSite" multiple placeholder="请选择站点">
        <el-option
          v-for="item in Site"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <!-- 请选择订单状态 -->
      <el-select size="mini" style="margin-left: 10px" v-model="selectListStatus" multiple placeholder="请选择订单状态">
        <el-option
          v-for="item in ListStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-button size="mini" type="primary" icon="el-icon-search" @click="CXDD" style="margin-left: 10px">查询订单</el-button>

      <el-button size="mini" type="primary" icon='el-icon-circle-plus' @click="BuDan">补单</el-button>

      <el-button size="mini" type="primary">今日订单量：{{count}}</el-button>

      <!-- 补单对话框 -->
      <el-dialog title="补单信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="站点" :label-width="formLabelWidth">
            <el-select v-model="form.site" placeholder="请选择站点">
              <el-option label="madrid-shop" value="madrid-shop"></el-option>
              <el-option label="cuirz" value="cuirz"></el-option>
              <el-option label="nihonbro" value="nihonbro"></el-option>
              <el-option label="jleague-shop" value="jleague-shop"></el-option>
              <el-option label="supermaillot" value="supermaillot"></el-option>
              <el-option label="fortmaillot" value="fortmaillot"></el-option>
              <el-option label="kickitshirts" value="kickitshirts"></el-option>
              <el-option label="mailloten" value="mailloten"></el-option>
              <el-option label="jerseykitboutique" value="jerseykitboutique"></el-option>
              <el-option label="jerseys-shop" value="jerseys-shop"></el-option>
               <el-option label="24camisetafutbol" value="24camisetafutbol"></el-option>
              <el-option label="honorjersey" value="honorjersey"></el-option>
              <el-option label="ligafoot" value="ligafoot"></el-option>
              <el-option label="beazl" value="beazl"></el-option>
              <el-option label="shopify" value="shopify"></el-option>
              <el-option label="silkdivas" value="silkdivas"></el-option>

            </el-select>
          </el-form-item>
          <el-form-item label="订单号" :label-width="formLabelWidth">
            <el-input v-model="form.ID_" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="QD_budan">确 定</el-button>
        </div>
      </el-dialog>
      
        <!-- v-loading="loading" -->
      <el-table
        stripe
        height="690"
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
        :data="tableData"
        border
        fit
        highlight-current-row
        style="border: 1px solid #000000;width:100%"
        :default-sort = "{prop: 'date_created_gmt', order: 'descending'}"
        @selection-change="selectionChange"
        >
        <el-table-column
          align="center"
          type="selection"
          label="全选"
          width="40px">
        </el-table-column>
      <!-- 站点 -->
        <el-table-column
          width="110px"
          label="站点"
          align="center"
          >
          <!-- :filters="Site"
          :filter-method="KO" -->
          <template slot-scope="scope">
            <div>{{scope.row.site}}</div>
          </template>
        </el-table-column>
      <!-- 订单id -->
        <el-table-column
          width="90px"
          prop="ID_"
          label="订单id"
          align="center"
        ></el-table-column>
      <!-- 订单状态 -->
      <!-- :filtered-value="['正在处理']" :filters="ListStatus"
          :filter-method="filterTag" -->
        <el-table-column
          width="100px"
          prop="status"
          label="订单状态"
          align="center"
          
          >
          <template slot-scope="scope">
            <el-tag
            :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
            disable-transitions>
              {{scope.row.status}}
            </el-tag>
          </template>
        </el-table-column>
      <!-- 下单时间 -->
        <el-table-column
          width="160px"
          prop="date_created_gmt"
          label="下单时间"
          align="center"
          sortable
        ></el-table-column>
      <!-- 付款时间 -->
        <el-table-column
          width="160px"
          prop="date_paid_gmt"
          label="付款时间"
          align="center"
          sortable
        ></el-table-column>
      <!-- 姓名 -->
        <el-table-column
          width="150px"
          property="name"
          label="姓名"
          align="center"
        ></el-table-column>
      <!-- 邮箱 -->
        <el-table-column
          width="200px"
          property="email"
          label="邮箱"
          align="center"
        ></el-table-column>
      <!-- 手机号 -->
        <el-table-column
          width="130px"
          prop="phone"
          label="手机号"
          align="center"
        ></el-table-column>
      <!-- 订单总额 -->
        <el-table-column
          width="100px"
          prop="total"
          label="订单总额"
          align="center"
        ></el-table-column>
        <!-- 运费总额 -->
        <el-table-column
            width="100px"
            prop="shipping_total"
            label="运费总额"
            align="center"
        ></el-table-column>
      <!-- 运输方式 -->
        <el-table-column
          width="90px"
          prop="shiptype"
          label="运输方式"
          align="center"
        ></el-table-column>
      <!-- 客户备注 -->
        <el-table-column
          prop="customer_note"
          label="客户备注"
          align="center"
        ></el-table-column>
      <!-- 操作 查看详情 -->
        <!-- <el-table-column
          width="100px"
          label="操作"
          v-loading="loading"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-view"
              @click="details(scope.$index, scope.row)"
              plain
              >查看</el-button>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="payment_method"
          label="支付方式"
          width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="transaction_id"
          label="交易号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bbun"
          label="贝宝用户名"
          align="center"
        ></el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pss"
        :page-size="ps"
        :total="Total"
        layout="total, sizes, prev, pager, next, jumper"
        style="display:flex; justify-content: center;">
      </el-pagination>
      
    </el-card>
    
    <!-- 导出数据二次确认框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>您确认要导出选中的数据吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- size-change	pageSize 改变时会触发	每页条数 -->
    <!-- current-change	currentPage 改变时会触发	当前页 -->
    <!-- current-page	当前页数，支持 .sync 修饰符	number	—	1 -->
    <!-- page-sizes	每页显示个数选择器的选项设置	number[]	—	[10, 20, 30, 40, 50, 100] -->
    <!-- page-size	每页显示条目个数，支持 .sync 修饰符	number	—	10 -->
    <!-- layout	组件布局，子组件名用逗号分隔	String	sizes, prev, pager, next, jumper, ->, total, slot	'prev, pager, next, jumper, ->, total' -->
    <!-- total	总条目数	number	—	— -->

  </div>
</template>

<script>
import { getOrderPage,getOrder_,getOrder,BD_,hqzzcl,Plhqgjwldh } from "../../api/api"
import table2excel from 'js-table2excel'
export default {
  data() {
    return {

      dialogVisible:false,
      fxkdcArray:[],

      UN:'',

      count:0,

      dialogFormVisible:false,
      form:{
        site:'',
        ID_:''
      },
      formLabelWidth: '120px',

      Site:[{ label: 'madrid-shop', value: 'madrid-shop' }, { label: 'cuirz', value: 'cuirz' }, { label: 'nihonbro', value: 'nihonbro' }, { label: 'jleague-shop', value: 'jleague-shop' }, { label: 'supermaillot', value: 'supermaillot' }, { label: 'fortmaillot', value: 'fortmaillot' }, { label: 'kickitshirts', value: 'kickitshirts' }, { label: 'mailloten', value: 'mailloten' }, { label: 'jerseykitboutique', value: 'jerseykitboutique' },{ label: 'jerseys-shop', value: 'jerseys-shop' },{ label: '24camisetafutbol', value: '24camisetafutbol' }, { label: 'honorjersey', value: 'honorjersey' }, { label: 'ligafoot', value: 'ligafoot' }, { label: 'beazl', value: 'beazl' }, { label: 'shopify', value: 'shopify' }, { label: 'silkdivas', value: 'silkdivas' }],
      selectSite:[],//筛选站点
      ListStatus:[{ label: '待付款', value: '待付款' }, { label: '正在处理', value: '正在处理' }, { label: '保留', value: '保留' }, { label: '已完成', value: '已完成' }, { label: '已取消', value: '已取消' }, { label: '已退款', value: '已退款' }, { label: '失败订单', value: '失败订单' }],
      selectListStatus:['正在处理'],//筛选订单状态
      value1: [],
      tableData: [],//订单列表
      loading: true,
      input: "",
      Data_:[],
      init_: 0,
      currentPage: 1,//默认第几页
      pss:[100,200,500,700,1000],
      ps:500,//默认每页条数
      Total:0
    };
  },
  created() {
    console.log(window.localStorage.getItem('un'));
    // console.log(document.cookie);
    var un = window.localStorage.getItem('un');

    if(un !== '' || un !== null || un !== undefined){
      this.UN = true;
    }else{
      this.UN =false;
    }

    if(un == '' || un == null || un == undefined){
      this.loading = true;
      return false;
    }
      var params = {
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrderPage(params).then(res => {
        this.Total = res.length;
        this.tableData = res;
        this.loading = false;
      })
      
      // var params = {
      //   Limit:this.ps,
      //   Offset:0,
      //   Site:this.selectSite,
      //   ListStatus:this.selectListStatus,
      //   date_created_gmt:this.value1
      // }
      // getOrder_(params).then(res => {
      //   for(var BB of res){
      //     if(BB.site == 'madrid-shop'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }else if(BB.site == 'cuirz'){
      //       BB.bbun = 'cuirz';
      //     }else if(BB.site == 'nihonbro'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }else if(BB.site == 'jleague-shop'){
      //       BB.bbun = 'libicheng23@163.com';
      //     }else if(BB.site == 'supermaillot'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }else if(BB.site == 'fortmaillot'){
      //       BB.bbun = 'vocotopa@gmail.com';
      //     }else if(BB.site == 'kickitshirts'){
      //       BB.bbun = 'madridshop.cc@gmail.com';
      //     }else if(BB.site == 'mailloten'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }else if(BB.site == 'ligafoot'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }else if(BB.site == 'beazl'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }else if(BB.site == 'top-w'){
      //       BB.bbun = 'onlinehossam4@gmail.com';
      //     }
      //   }
      // })
        

      /*hqzzcl().then(res => {
        var startTime = new Date(new Date(new Date().toLocaleDateString()).getTime());
        var endTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
        // console.log(startTime,endTime);
        // console.log(startTime.getTime());
        var sT = startTime.getTime();
        var eT = endTime.getTime();
        // var a = '2022-12-30 22:22:22';
        // if(endTime > startTime){
        //   console.log(222);
        // }
        var array = [];
        for(var i of res){
          array.push(new Date(i.date_paid_gmt).getTime());
        }
        // console.log(array);
        for(var i of array){
          if(i >= sT && i <= eT){
            this.count += 1;
          }
        }
      })*/
    hqzzcl().then(res => {
      this.count = res[0].count;
    })
  },
  methods: {

    //复选框
    selectionChange(selection){
      // console.log(selection);
      this.fxkdcArray = selection;
      // console.log(this.fxkdcArray);
    },

    //导出数据(二次确认)
    export_(){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true,
        })
        this.loading = true;
        return false;
      }
      this.dialogVisible = true;
    },

    reduceData (res) {
      return res.reduce((total, currentValue) => {
        return {
          ...total,
          ...Object.keys(currentValue).reduce((_r, _c) => { // Object.keys() 返回一个给定对象的属性名
            if (total[_c]) {
              total[_c].push(currentValue[_c])
            } else {
              total[_c] = [currentValue[_c]]
            }
            return total
          }, {})
        }
      }, {})
    },


    //导出数据(确认导出)
    handleUpload(){
      this.dialogVisible = false;
      if(this.fxkdcArray.length == 0){
        this.$message({
          message: "导出数据为空,请先选中您要导出的数据",
          type: "warning",
          showClose: true
        })
        return false;
      }else{
        let aaa = this.fxkdcArray.map((item,index) => {
          return Object.assign({},{'site':item.site,'ID_':item.ID_});
        })
        // console.log(aaa);
        let ppp = this.reduceData (aaa);
        console.log(ppp.site.length);
        Plhqgjwldh(ppp).then(res => {
          console.log(res);
        })
        let column = [
          {
            title: '站点',
            key: 'site',
            type: 'text'
          },
          {
            title: '订单ID',
            key: 'ID_',
            type: 'text'
          },
          {
            title:'订单状态',
            key:'status',
            type:'text'
          },
          {
            title:'下单时间',
            key:'date_created_gmt',
            type:'text'
          },
          {
            title:'付款时间',
            key:'date_paid_gmt',
            type:'text'
          },
          {
            title:'姓名',
            key:'name',
            type:'text'
          },
          {
            title:'邮箱',
            key:'email',
            type:'text'
          },
          {
            title:'手机号',
            key:'phone',
            type:'text'
          },
          {
            title: '订单总额',
            key: 'total',
            type: 'text'
          },
          {
            title: '运费总额',
            key: 'shipping_total',
            type: 'text'
          },
          {
            title:'运输方式',
            key:'shiptype',
            type:'text'
          },
          {
            title:'客户备注',
            key:'customer_note',
            type:'text'
          },
          {
            title:'支付方式',
            key:'payment_method',
            type:'text'
          },
          {
            title: '交易号',
            key: 'transaction_id',
            type: 'text'
          },
          {
            title: '贝宝用户名',
            key: 'bbun',
            type: 'text'
          },
        ]
        table2excel(column, this.fxkdcArray, "订单列表.xls");
      }
    },

    // 域名管理页面跳转
    Domain(){
      const domain_ = this.$router.resolve({ path: "/home/Domain" });
      window.open(domain_.href, '_blank');
    },

    // SKU页面跳转
    SKU(){
      const SKU = this.$router.resolve({ path: "/home/SKU" });
      window.open(SKU.href, '_blank');
    },

    // 时间筛选
    goTime(){
      const _Time = this.$router.resolve({ path: "/home/TimeScreen" });
      window.open(_Time.href, '_blank');
    },

    // 查看操作记录
    goLog(){
      const log_ = this.$router.resolve({ path: "/home/log" });
      window.open(log_.href, '_blank');
    },

    // 补单
    BuDan(){
      this.dialogFormVisible = true;
    },

    // 确定补单
    QD_budan(){
      //console.log(this.form);
      this.dialogFormVisible = false;
      BD_(this.form).then(res => {
        console.log(111);
        console.log(res);
      })
    },

    // 搜索新页面
    newSearch(){
      const search_ = this.$router.resolve({ path: "/home/newSearch" });
      window.open(search_.href, '_blank');
    },

    //设置每页几条
    handleSizeChange(val) {
      this.loading = true;
      this.ps = val;
      var limit = val;
      var offset = (this.currentPage - 1) * val;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrder_(params).then(res => {
        this.tableData = res;
        this.loading = false;
      })
    },

    //前往第几页
    handleCurrentChange(val) {
      this.loading = true;
      this.currentPage = val;
      var limit = this.ps;
      var offset = (val - 1) * this.ps;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrder_(params).then(res => {
        this.tableData = res;
        this.loading = false;
      })
    },

    // 查询订单
    CXDD(){
      this.loading = true;
      var params = {
        Limit:this.ps,
        Offset:(this.currentPage - 1) * this.ps,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrder_(params).then(res => {
        // for(var BB of res){
        //   if(BB.site == 'madrid-shop'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }else if(BB.site == 'cuirz'){
        //     BB.bbun = 'cuirz';
        //   }else if(BB.site == 'nihonbro'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }else if(BB.site == 'jleague-shop'){
        //     BB.bbun = 'libicheng23@163.com';
        //   }else if(BB.site == 'supermaillot'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }else if(BB.site == 'fortmaillot'){
        //     BB.bbun = 'vocotopa@gmail.com';
        //   }else if(BB.site == 'kickitshirts'){
        //     BB.bbun = 'madridshop.cc@gmail.com';
        //   }else if(BB.site == 'mailloten'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }else if(BB.site == 'ligafoot'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }else if(BB.site == 'beazl'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }else if(BB.site == 'top-w'){
        //     BB.bbun = 'onlinehossam4@gmail.com';
        //   }
        // }
        this.tableData = res;
        this.loading = false;
      })
      var params = {
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrderPage(params).then(res => {
        this.Total = res.length;
      })
    },

    //时间格式化
    utc2timestamp(utc_datetime) {
    
    // 处理成为时间戳
    var timestamp = new Date(Date.parse(utc_datetime));
    timestamp = timestamp.getTime();
    
    // 增加8个小时，北京时间比utc时间多八个时区
    // var timestamp = timestamp + 8 * 60 * 60 * 1000;
    return timestamp;
    },

    //时间范围筛选
    block(time){
      // debugger
      // console.log(time);
      this.loading = true;
      if(!time){
        this.value1 = [];
        this.loading = false;
        return false
      }
      var timestamp,timestamp_ = '';
      timestamp = Date.parse(this.value1[0]);
      timestamp_ = Date.parse(this.value1[1]);
      // console.log(timestamp,timestamp_);
      var arr = [];
      getOrder().then(res => {
        for(var i = 0;i < res.length;i++){
          if(res[i].date_paid_gmt == null || res[i].date_paid_gmt == undefined || res[i].date_paid_gmt == '无'){
            continue
          }else{
            var Time = this.utc2timestamp(res[i].date_paid_gmt);
            if(Time > timestamp && Time < timestamp_){
              arr.push(res[i]);
            }
          }
        }
        this.tableData = arr;
        this.Total = arr.length;
        this.loading = false;
      })
    },

    //商品列表
    goProduct(){
      const product_ = this.$router.resolve({path: "/home/productlist"});
      window.open(product_.href, '_blank');
    },

    //图表数据
    goData(){
      const chart = this.$router.resolve({path:"/home/chart"});
      window.open(chart.href, '_blank');
    },

    //查看详情
    details(index, row){
      const detail_ = this.$router.resolve({ path: "/home/Orderdetail", query: { id: row.id } });
      window.open(detail_.href, '_blank');
    },

    //追踪订单
    trace(){
      const trace_ = this.$router.resolve({path:"/home/trace"});
      window.open(trace_.href, '_blank');
    },

    //搜索
    search(){
      const search_ = this.$router.resolve({ path: "/home/search", query: { id: this.input}});
      window.open(search_.href, '_blank');
      // this.loading = true;
      // getOrder().then(res => {
      //   var arr = [];
      //   for(var i = 0;i < res.length;i++){
      //     if(res[i].ID_ == this.input){
      //       arr.push(res[i]);
      //     }
      //   }
      //   this.tableData = arr;
      //   if(arr.length == 0){
      //     this.$message({
      //       showClose: true,
      //       message: '您查找的订单不存在，请核对后重新查找',
      //       type: 'warning'
      //     });
      //   }
      //   this.loading = false;
      // })
    },

    //重置
    reset(){
      this.loading = true;
      this.input = '';
      getOrder().then(res => {
        var res_ = res.reverse();
        this.tableData = res_;
      })
      this.loading = false;
    }
  }
};

</script>

<style lang="scss" scoped>
.block{
  margin-left: 10px;
  display: inline-block;
}
.el-table {
  margin-top: 20px;
  text-align: center;
}
.list{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn{
  margin-top: 10px;
}
.deb{
  display: inline-block;
  margin-left: 10px;
}
// 隐藏数字输入框后面的按钮
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
// 对话框
.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 10px 0 10px 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}

// 滚动条的宽度
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
width: 16px; // 横向滚动条
height: 6px; // 纵向滚动条 必写
}
// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
background-color: #409eff;
border-radius: 10px;
}
</style>
